import { TOPIC_NAMES } from 'crm-message-bus/types/MessageTopics';
import { useObjectId } from './useObjectId';
import { useObjectTypeId } from './useObjectTypeId';
import { useProperty } from './useProperty';
import { useOnCrmMessageTopic } from 'crm-message-bus/useOnCrmMessageTopic';
import { useCallback } from 'react';
function messageIsForProperty({
  payload,
  property,
  objectId,
  objectTypeId
}) {
  return payload.some(updateObjectData => {
    var _updateObjectData$pro;
    return updateObjectData.objectId === objectId && updateObjectData.objectTypeId === objectTypeId && ((_updateObjectData$pro = updateObjectData.propertyNames) === null || _updateObjectData$pro === void 0 ? void 0 : _updateObjectData$pro.includes(property.name));
  });
}
export function useOnUpdatedValue(fn) {
  const objectId = useObjectId();
  const objectTypeId = useObjectTypeId();
  const property = useProperty();
  useOnCrmMessageTopic(TOPIC_NAMES.UPDATE_OBJECTS, useCallback(payload => {
    if (messageIsForProperty({
      payload,
      property,
      objectId,
      objectTypeId
    })) {
      fn();
    }
  }, [objectId, objectTypeId, property, fn]));
}